import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import { List, ListItem } from 'material-ui/List';
import SearchIcon from 'material-ui/svg-icons/action/search';
import TextField from 'material-ui/TextField';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
import Toggle from 'material-ui/Toggle';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import { Subheader } from 'material-ui';
import COLORS from '../../theme/colors';

import './webex_channels.scss';

export default class WebexChannels extends React.Component {
  static propTypes = {
    teams: PropTypes.array.isRequired,
    addToBlacklist: PropTypes.func.isRequired,
    removeFromBlacklist: PropTypes.func.isRequired,
    updateBlacklist: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      filterText: '',
    };
  }

  getWebexChannels(team) {
    const filteredChannels = this.filterChannels(team);
    if (filteredChannels.length === 0) return null;
    return (
      <List key={team.id}>
        {filteredChannels.length > 0 && <Subheader >{team.name}</Subheader>}
        {filteredChannels}
      </List>
    );
  }

  filterChannels(team) {
    const filterText = this.state.filterText.toLowerCase();
    return team.rooms.filter(room => room.title.toLowerCase().indexOf(filterText) !== -1)
      .map((room) => {
        const toggle = (
          <Toggle
            toggled={!room.blacklisted}
            onToggle={(event, checked) => {
              const { addToBlacklist, removeFromBlacklist } = this.props;
              const action = checked
                ? removeFromBlacklist
                : addToBlacklist;
              action(room.id, room.teamId);
            }}
          />
        );

        return (<ListItem
          style={{ borderBottom: `1px solid ${COLORS.gray}` }}
          key={room.id}
          primaryText={`#${room.title}`}
          rightToggle={toggle}
        />);
      });
  }

  render() {
    const rooms = _.flatten(_.map(this.props.teams, 'rooms'));
    const selectAllButton = (
      <RaisedButton
        labelColor={COLORS.purple}
        label="All"
        onClick={() => {
          const removeIds = _.map(rooms, 'id');
          this.props.updateBlacklist({ removeIds });
        }}
      />
    );
    const selectNoneButton = (
      <RaisedButton
        labelColor={COLORS.purple}
        label="None"
        onClick={() => {
          const addIds = _.map(rooms, 'id');
          this.props.updateBlacklist({ addIds });
        }}
      />
    );

    return (
      <div className="webex-channels">
        <Card>
          <CardHeader
            title={'Manage Settings'}
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            <p>
              {
                'TeamHub monitors only the messages in your public Webex spaces. ' +
                'It does not monitor or display messages from private chats.'
              }
            </p>
            <p>
              {
                'Configure specific public Webex spaces you want TeamHub to monitor ' +
                'and use as content source for your TV application. ' +
                'You can switch the monitoring on and off at any time.'
              }
            </p>
          </CardText>
          <CardText expandable>
            <Toolbar>
              <ToolbarGroup firstChild className="search-bar">
                <SearchIcon color={COLORS.purple} className="search-icon" />
                <TextField
                  className="filter-input"
                  hintText="Filter channels"
                  underlineStyle={{ borderColor: COLORS.purple }}
                  underlineFocusStyle={{ borderColor: COLORS.purple }}
                  onChange={(_event, newValue) => {
                    this.setState({ filterText: newValue });
                  }}
                />
              </ToolbarGroup>
              <MediaQuery minDeviceWidth={901}>
                <ToolbarGroup lastChild>
                  {selectAllButton}
                  {selectNoneButton}
                </ToolbarGroup>
              </MediaQuery>
            </Toolbar>
            <MediaQuery maxDeviceWidth={900} className="filter-buttons">
              {selectAllButton}
              {selectNoneButton}
            </MediaQuery>
          </CardText>
          <CardText expandable >
            <div className="channels">
              {this.props.teams.map(team => this.getWebexChannels(team))}
            </div>
          </CardText>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/webex_channels/webex_channels.jsx